import styled from 'styled-components';
import { Text, FlexColumn, SvgIcon } from '@make-software/tg-mini-app-ui';

export const ProjectRoundContainer = styled.div<{ noSecondary?: boolean }>(
  ({ theme, noSecondary }) =>
    theme.withMedia({
      background:
        'linear-gradient(180deg, rgba(251, 111, 106, 0.30) 0%, rgba(251, 111, 106, 0.00) 106.13%), #30313B;',
      display: 'flex',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #41424E',
      width: '50%',
      gap: '5px',
      flex: '1 0 0',
      alignItems: 'flex-start',
      flexDirection: 'column',
      justifyContent: noSecondary ? 'center' : 'flex-start',
      cursor: 'pointer'
    })
);

export const SupportedFansText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '16px',
    lineHeight: '140%',
    fontWeight: '700',
    fontVariantNumeric: 'lining-nums tabular-nums',
    fontFamily: 'Inter'
  })
);

export const StyledSvgIcon = styled(SvgIcon)<{ isSecondRound?: boolean }>(
  ({ theme, isSecondRound }) =>
    theme.withMedia({
      'svg path': {
        fill: isSecondRound ? '#A0B3FF' : '#FB6F6A'
      }
    })
);

export const RoundInfoText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    fontVariantNumeric: 'lining-nums tabular-nums',
    color: '#A9AAAD',
    fontFamily: 'Inter'
  })
);

export const FeeText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    fontFamily: 'JetBrains Mono, monospace',
    fontWeight: '400',
    lineHeight: '140%'
  })
);

export const RoundContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    padding: '20px 17px 32px 17px',
    backgroundColor: '#1C1D24',
    alignSelf: 'stretch',
    marginTop: '20px'
  })
);

export const AmountBoxContainer = styled(FlexColumn)<{ selected?: boolean }>(
  ({ theme, selected }) =>
    theme.withMedia({
      padding: '4px 16px',
      height: '36px',
      backgroundColor: '#3A3B46',
      borderRadius: '4px',
      border: selected ? '1px solid #FB6F6A' : 'none',
      width: '25%'
    })
);

export const AmountText = styled(Text)<{ selected?: boolean }>(({ theme, selected }) =>
  theme.withMedia({
    fontSize: '14px',
    fontFamily: 'JetBrains Mono, monospace',
    fontWeight: '400',
    lineHeight: '140%',
    color: selected ? '#FB6F6A' : '#A9AAAD'
  })
);

export const ButtonAmountText = styled(AmountText)<{ disabled?: boolean }>(({ theme, disabled }) =>
  theme.withMedia({
    fontSize: '14px',
    fontFamily: 'JetBrains Mono, monospace',
    fontWeight: '700',
    lineHeight: '140%',
    color: disabled ? '#64666B' : '#FFF'
  })
);
